module.exports = {
    // apiURL: 'http://localhost:8080/api/'            //dev
    apiURL: 'http://flvacationhouse.com:8080/api/'  //prod
}